import React from 'react';
import images from '_images';
import { colors } from '_styles';
import styled from 'styled-components';
import parse from 'html-react-parser';

const Container = styled.div`
  margin: 0;
`;

const Content = styled.div`
  all: initial;
  font-family: Roboto, sans-serif !important;
  position: relative;
  font-size: 15px !important;
  font-weight: 500 !important;
  display: block;
  color: #404040 !important;
  text-align: left !important;

  &:before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    width: 17px;
    height: 17px;
    background-size: 17px;
    background-repeat: no-repeat;
    background-image: ${({ content }) => ((content === 'email') ? `url(${images.icons.email})}` : null)};
    background-image: ${({ content }) => ((content === 'phone') ? `url(${images.icons.phone})}` : null)};
    background-image: ${({ content }) => ((content === 'link') ? `url(${images.icons.link})}` : null)};
  }

  p {
    margin: 0 !important;
  }
`;

const Text = styled.span``;

const Link = styled.a`
  margin-left: 35px;
  text-decoration: none;
  padding: 0;
  color: ${colors.RC_ACTION};
  text-align: left !important;
`;

const Contact = ({
  address, email, phone, link
}) => (
  <Container>
    {
      address
        && !address.includes('null')
        ? (
          <Content>
            <Text>{parse(address)}</Text>
          </Content>
        ) : null
    }
    {
      email
        && !email.includes('null')
        ? (
          <Content content="email">
            <Link href={`mailto:${email}`}>{email}</Link>
          </Content>
        ) : null
    }
    {
      phone
        && !phone.includes('null')
        ? (
          <Content content="phone">
            <Text style={{ marginLeft: 25 }}>{phone}</Text>
          </Content>
        ) : null
    }
    {
      link
        && !link.includes('null')
        ? (
          <Content content="link">
            <Link href={link} alt="click to visit the website" target="_blank">{link}</Link>
          </Content>
        ) : null
    }
  </Container>
);

export default Contact;
